import React from "react";
import { useQuery, gql } from "@apollo/client";
import dynamic from "next/dynamic";

const MarkdownDisplay = dynamic(() => import("./MarkdownDisplay"), {
  loading: () => <div></div>,
});

const GLOBAL_PROMO_QUERY = gql`
  {
    globalPromo {
      markdown
      backgroundColor
      textColor
    }
  }
`;

function GlobalPromoBanner() {
  const { loading, error, data } = useQuery(GLOBAL_PROMO_QUERY);

  if (loading || error || !data?.globalPromo) return null;

  return <MarkdownDisplay {...data} />;
}

export default React.memo(GlobalPromoBanner);
